import './ToolBubble.css'

import { useState } from 'react'

import { usePhotoObjectUrl } from '../hooks/usePhotoObjectUrl'
import { cx } from '../utilities/cx'
import { Icon, IconName } from './Icon'

export type ToolUseData = {
  name: string
  input?: Record<string, unknown>
  meta?: Record<string, unknown>
}

type ToolConfig = {
  icon: IconName
  activeText: (input?: Record<string, unknown>) => string
  completedText: (input?: Record<string, unknown>) => string
}

const toolConfigs: Record<string, ToolConfig> = {
  updateProfile: {
    icon: 'user',
    activeText: () => 'Updating your profile',
    completedText: () => 'Updated your profile',
  },
  recallConversation: {
    icon: 'message-circle',
    activeText: () => 'Recalling a past conversation',
    completedText: () => 'Recalled a past conversation',
  },
  examinePhoto: {
    icon: 'camera',
    activeText: () => 'Looking at a photo',
    completedText: () => 'Looked at a photo',
  },
  deletePhoto: {
    icon: 'trash-2',
    activeText: () => 'Deleting a photo',
    completedText: () => 'Deleted a photo',
  },
  setMainPhoto: {
    icon: 'star',
    activeText: () => 'Setting main photo',
    completedText: () => 'Set main photo',
  },
}

const defaultConfig: ToolConfig = {
  icon: 'loader',
  activeText: () => 'Working on something',
  completedText: () => 'Finished working',
}

export type ToolBubbleProps = {
  toolUse: ToolUseData
  active?: boolean
}

export const ToolBubble = (props: ToolBubbleProps) => {
  const { toolUse, active } = props
  const [photoError, setPhotoError] = useState(false)

  const config = toolConfigs[toolUse.name] ?? defaultConfig

  const photoId = toolUse.meta?.['photoId'] as string | undefined
  const photoUrl = usePhotoObjectUrl(photoId, 200)
  const isExaminePhoto = toolUse.name === 'examinePhoto'
  const showThumbnail = !!(isExaminePhoto && photoUrl && !active && !photoError)

  let text: string
  if (active) {
    text = config.activeText(toolUse.input)
  } else if (isExaminePhoto && photoError) {
    text = 'Looked at a deleted photo'
  } else {
    text = config.completedText(toolUse.input)
  }

  return (
    <div className={cx('tool-bubble', active && 'tool-bubble--active')}>
      <div className="tool-bubble__header">
        <Icon name={config.icon} className="tool-bubble__icon" />
        <span className="tool-bubble__text">{text}</span>
      </div>
      {showThumbnail && (
        <img
          src={photoUrl}
          alt=""
          className="tool-bubble__thumbnail"
          onError={() => setPhotoError(true)}
        />
      )}
    </div>
  )
}
